<template>
	<div class="totalGrade-range">
		<div class="totalGrade-chart">
			<div class="totalGrade-title">
				<span>总分分布</span>
				<span>学生总分分布，可反映本次考试学生的综合学业水平分布状态。</span>
			</div>
			<div class="trend-header">
				<div class="trend-item">
					<div>{{ maxScore }}</div>
					<div>最高分</div>
				</div>
				<div class="trend-item">
					<div>{{ minScore }}</div>
					<div>最低分</div>
				</div>
				<div class="trend-item">
					<div>{{ avgScore }}</div>
					<div>平均分</div>
				</div>
			</div>
			<div class="totalGrade-canvas">
				<render-Total-Grade :newGradingData="gradingData" v-if="gradingData.length" />
				<div class="total-canvas-desc" v-if="!isShowMore">
					<!--                    isShowMore-->
					<p class="total-item" v-for="(item, index) in gradingData" :key="index" v-show="index < 10">
						<span>{{ item.gradeSection }}区间</span>
						<b> {{ item.gradeSectionNum }}</b>
						<span>人</span>
					</p>
				</div>
				<div class="total-canvas-desc" v-else>
					<!--                    isShowMore-->
					<p class="total-item" v-for="(item, index) in gradingData" :key="index">
						<span>{{ item.gradeSection }}区间</span>
						<b> {{ item.gradeSectionNum }}</b>
						<span>人</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
		renderTotalGrade: () => import('./echarts/RenderTotalGrade')
	},
	props: {
		gradingData: {
			type: Array,
			default: () => [],
			required: true
		},
		isShowMore: {
			type: Boolean,
			default: true
		},
		maxScore: String,
		minScore: String,
		avgScore: String
	},
	data() {
		return {
			// newGradingData: []
		}
	},
	watch: {
		gradingData: {
			handler() {
				// this.newGradingData = val.reverse()
			}
		}
	}
}
</script>

<style lang="less" scoped>
@media print {
	.total-canvas-desc {
		overflow: hidden;
	}
}
.totalGrade-range {
	margin: 10px 0px;
	padding: 30px;
	height: auto;
	background-color: #fff;
	border: 1px solid #ebeef5;
	border-radius: 3px;
	transition: 0.3s;
	.totalGrade-chart {
		height: auto;
		// background-color: skyblue;
		.totalGrade-title {
			display: flex;
			flex-direction: column;
			margin-bottom: 20px;
			& > span:nth-child(1) {
				font-size: 18px;
				font-weight: bold;
				color: #333;
				margin-right: 20px;
			}
			& > span:nth-child(2) {
				font-size: 12px;
				color: #6a6a6a;
				margin-top: 10px;
			}
		}
		.trend-header {
			height: 120px;
			// margin-left: -10px;
			// margin-right: -10px;
			text-align: center;
			box-sizing: border-box;
			// background-color: gold;
			display: flex;
			.trend-item {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-content: center;
				width: 365px;
				height: 100%;
				border: 1px solid rgb(231, 231, 231);
				background: rgb(250, 250, 250);
				color: #303133;
				padding-left: 10px;
				padding-right: 10px;
				margin-right: 20px;
				&:nth-child(2) {
					div:nth-child(1) {
						color: #f05f50;
					}
				}
				&:last-child {
					div:nth-child(1) {
						color: #00a04a;
					}
					margin-right: 0;
				}
				& > div:nth-child(1) {
					color: #fcbb12;
					font-size: 32px;
					margin-top: 5px;
				}
				& > div:nth-child(2) {
					font-size: 12px;
					margin-bottom: 12px;
				}
			}
		}
		.totalGrade-canvas {
			margin-top: 20px;
			margin-bottom: 10px;
			height: 362px;
			// background-color: wheat;
			box-sizing: border-box;
			// overflow: hidden;
			.totalGrade-canvas-charts {
				float: left;
				width: 70%;
				height: 100%;
				float: left;
				background-color: white;
			}
			.total-canvas-desc {
				width: 29.3%;
				height: 100%;
				overflow-y: scroll;
				float: left;
				border: 1px solid #ebeef5;
				background-color: #fff;
				color: #303133;
				.total-item {
					width: 82%;
					font-size: 12px;
					padding-top: 10px;
					padding-bottom: 10px;
					margin: 0 auto;
					border-bottom: 1px dashed #eee;
					& > span:nth-child(1) {
						display: inline-block;
						width: 63%;
					}
					& > b {
						display: inline-block;
						width: 30%;
						text-align: center;
					}
					& > span:nth-child(2) {
						display: inline-block;
						width: 10%;
					}
				}
			}
		}
		.analysis-conclusion {
			text-align: justify;
			margin-top: 20px;
			font-size: 14px;
			padding: 20px;
			background: rgba(197, 233, 248, 0.2);
			& > p:nth-child(1) {
				margin-bottom: 10px;
			}
		}
	}
	&:hover {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}
	@media print {
		.total-canvas-desc {
			overflow: hidden;
		}
	}
}
</style>
